import React, { useState } from 'react';
import { useUIVisibility } from '../contexts/UIVisibilityContext';
import './UIToggleButton.css';

const UIToggleButton: React.FC = () => {
  const { isHeaderVisible, isFooterVisible, toggleHeader, toggleFooter } = useUIVisibility();
  const [isHidden, setIsHidden] = useState(true); // 初期状態を閉じた状態に変更

  const toggleHidden = () => {
    setIsHidden(!isHidden);
  };

  return (
    <>
      {/* ヘッダーを隠すボタン（上） */}
      {!isHidden && (
        <button
          className="ui-toggle-button header-toggle"
          onClick={toggleHeader}
          title={isHeaderVisible ? 'ヘッダーを隠す' : 'ヘッダーを表示'}
          aria-label={isHeaderVisible ? 'ヘッダーを隠す' : 'ヘッダーを表示'}
        >
          ▲
        </button>
      )}

      {/* トグルボタン（開く/閉じる・中央） */}
      <button
        className="toggle-button"
        onClick={toggleHidden}
        title={isHidden ? 'メニューを開く' : 'メニューを閉じる'}
        aria-label={isHidden ? 'メニューを開く' : 'メニューを閉じる'}
      >
        {isHidden ? '◀' : '▶'}
      </button>

      {/* フッターを隠すボタン（下） */}
      {!isHidden && (
        <button
          className="ui-toggle-button footer-toggle"
          onClick={toggleFooter}
          title={isFooterVisible ? 'フッターを隠す' : 'フッターを表示'}
          aria-label={isFooterVisible ? 'フッターを隠す' : 'フッターを表示'}
        >
          ▼
        </button>
      )}
    </>
  );
};

export default UIToggleButton;
